export default __webpack_public_path__ + "static/media/right-mobile.c133143d.svg";